// Generated by ts-to-zod
import { z } from 'zod';

export const logLevelSchema = z.union([
  z.literal('INFO'),
  z.literal('ERROR'),
  z.literal('WARNING'),
]);

export const runLogSchema = z.object({
  timestamp: z.string(),
  logLevel: logLevelSchema,
  details: z.string(),
});
